import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const money = (n) =>
  `JMD $${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fetchCatalog = async () => (await axios.get(`${API}/catalog`)).data;

export const fetchProducts = async (category, sub) => {
  const params = {};
  if (category) params.category = category;
  if (sub) params.sub = sub;
  return (await axios.get(`${API}/products`, { params })).data;
};

export const uploadArtwork = async (file) => {
  const form = new FormData();
  form.append("file", file);
  return (await axios.post(`${API}/uploads`, form)).data;
};

export const fetchProductImages = async () => (await axios.get(`${API}/product-images`)).data;

export const adminUploadProductImage = async (slug, file, key) => {
  const form = new FormData();
  form.append("file", file);
  return (
    await axios.post(`${API}/admin/product-images/${slug}`, form, {
      headers: { "X-Admin-Key": key },
    })
  ).data;
};

export const adminDeleteProductImage = async (slug, key) =>
  (
    await axios.delete(`${API}/admin/product-images/${slug}`, {
      headers: { "X-Admin-Key": key },
    })
  ).data;

export const adminGetTracking = async (key) =>
  (await axios.get(`${API}/admin/settings/tracking`, { headers: { "X-Admin-Key": key } })).data;

export const adminSaveTracking = async (payload, key) =>
  (
    await axios.post(`${API}/admin/settings/tracking`, payload, {
      headers: { "X-Admin-Key": key },
    })
  ).data;

export const createOrder = async (payload) =>
  (await axios.post(`${API}/orders`, payload)).data;

export const createBulkInquiry = async (payload) =>
  (await axios.post(`${API}/bulk-inquiry`, payload)).data;

export const adminFetch = async (section, key) =>
  (
    await axios.get(`${API}/admin/${section}`, {
      headers: { "X-Admin-Key": key },
    })
  ).data;

export const adminSetOrderStatus = async (orderId, status, key, confirmUnpaid = false) =>
  (
    await axios.patch(
      `${API}/admin/orders/${orderId}/status`,
      { status, confirm_unpaid: confirmUnpaid },
      { headers: { "X-Admin-Key": key } }
    )
  ).data;

export const adminConfirmCash = async (orderId, key, amount) =>
  (
    await axios.post(
      `${API}/admin/orders/${orderId}/payments/confirm-cash`,
      amount ? { amount } : {},
      { headers: { "X-Admin-Key": key } }
    )
  ).data;

export const payBalance = async (orderId) =>
  (await axios.post(`${API}/orders/${orderId}/pay-balance`)).data;

export const adminDeleteOrder = async (orderId, key) =>
  (
    await axios.delete(`${API}/admin/orders/${orderId}`, {
      headers: { "X-Admin-Key": key },
    })
  ).data;

export const trackOrder = async (orderId) =>
  (await axios.get(`${API}/orders/track/${encodeURIComponent(orderId)}`)).data;

export const adminGetWiPay = async (key) =>
  (await axios.get(`${API}/admin/settings/wipay`, { headers: { "X-Admin-Key": key } })).data;

export const adminSaveWiPay = async (payload, key) =>
  (
    await axios.post(`${API}/admin/settings/wipay`, payload, {
      headers: { "X-Admin-Key": key },
    })
  ).data;

export const adminUploadProof = async (orderId, file, key) => {
  const form = new FormData();
  form.append("file", file);
  return (
    await axios.post(`${API}/admin/orders/${orderId}/proof`, form, {
      headers: { "X-Admin-Key": key },
    })
  ).data;
};

export const submitProofDecision = async (orderId, decision, note) =>
  (await axios.post(`${API}/orders/${orderId}/proof-decision`, { decision, note })).data;

export { DISCOUNT_RULES, bulkPercent, nextTierHint } from "@/lib/discounts";
